import './BuyCreditsScreen.less';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Meta from '../../components/Meta';
import PreviewInvoice from '../../components/PreviewInvoice/PreviewInvoice';
import { getProducts } from '../../app/ActionTypes/productActionTypes';
import { AppDispatch, RootState } from '../../app/store';
import { Resource } from '../../enums/common';
import { Link } from 'react-router-dom';
import { useUserAccess } from '../../hooks/useUserAccess';
import { useAbility } from '../../hooks/useAbility';
import { getTeamName } from '../../services/account.service';
import { convertSubscriptionDataToStripeSubscription } from '../../services/subscription';

const BuyCreditsScreen: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentTeamAccount } = useUserAccess();
  const { currentAbility } = useAbility();
  const { subscriptionInfo, loading: isLoadingSubscription } = useSelector(
    (state: RootState) => state.subscription
  );

  const shouldShowInvoice =
    !isLoadingSubscription &&
    subscriptionInfo &&
    currentAbility &&
    currentAbility.can(
      'manage',
      Resource.Subscription,
      convertSubscriptionDataToStripeSubscription(subscriptionInfo.subscription)
    );

  useEffect(() => {
    if (shouldShowInvoice) {
      dispatch(getProducts());
    }
  }, [shouldShowInvoice]);

  return (
    <>
      <Meta name="Cirra AI - Buy Credits" />
      <div className="buying-credits-main-screen-element">
        <div id="buy-credits-container">
          {shouldShowInvoice && <PreviewInvoice />}
          {!shouldShowInvoice && (
            <div className="buy-credits-error-container">
              <h2>Insufficient permissions</h2>
              {currentTeamAccount ? (
                <p>
                  You do not have permission to manage the subscription of team{' '}
                  {getTeamName(currentTeamAccount.team)}.<br />
                  Please contact your team onwer.
                </p>
              ) : (
                <p>
                  Something went wrong. Please contact{' '}
                  <Link to="mailto:support@cirra.ai">support@cirra.ai</Link>
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BuyCreditsScreen;
